module.exports = "footer {\r\n    position: absolute;\r\n    display: flex;\r\n    bottom: 0;\r\n    width: 100vw;\r\n    justify-content: center;\r\n}"